import Marquee from "react-fast-marquee";

const BRANDS = [
  "CHNKS",
  "chappers",
  "Dietico Health Foods",
  "Offduty India",
  "Project Shades",
  "The Noon Store",
  "032c Workshop",
  "Hebtroco",
  "Lucy and Yak",
  "KIMS-Kingsraj",
  "Jupiter Hospital",
  "Aarvy Healthcare",
  "Paras Hospital",
];

export default function BrandMarquee({ dark = false }) {
  return (
    <div
      className={`relative py-8 border-y ${
        dark
          ? "bg-[#0B0B0B] text-[#FFC629] border-white/10"
          : "border-[#0B0B0B]/10"
      }`}
    >
      <Marquee gradient={false} speed={38} pauseOnHover>
        {BRANDS.concat(BRANDS).map((b, i) => (
          <span key={i} className="marquee-item">
            {b}
            <span className="dot" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
